import { createActionTypes } from "@helpers/redux-helpers";

export const setProfileActionType = "profile/set";

export const getProfileActionTypes = createActionTypes("profile/get");

export const updateProfileActionTypes = createActionTypes("profile/update");

export const uploadAvatarActionTypes = createActionTypes(
  "profile/avatar/upload",
);

export const deleteAvatarActionTypes = createActionTypes(
  "profile/avatar/delete",
);

export const uploadBannerActionTypes = createActionTypes(
  "profile/banner/upload",
);

export const deleteBannerActionTypes = createActionTypes(
  "profile/banner/delete",
);

export const clearProfileStatesActionType = "profile/clearStates";

export const incrementPostsCounterActionType = "profile/postCounter/incremet";

export const decrementPostsCounterActionType = "profile/postCounter/decrement";

export const clearAvatarSuccessActionType = "profile/avatar/clearSuccess";

export const clearAvatarErrorActionType = "profile/avatar/clearError";

export const setMySubscriptionActionType = "profile/subscription/set";

export const addMySubscriptionActionType = "profile/subscription/add";

export const removeMySubscriptionActionType = "profile/subscription/remove";

export const reorderSubscriptionsActionType = "profile/subscriptions/reorder";

export const disconnectMetamaskActionTypes = createActionTypes(
  "profile/metamask/disconnect",
);

export const disconnectPayoutMethodActionTypes = createActionTypes(
  "profile/payoutMethod/disconnect",
);

export const disconnectPayPalActionTypes = createActionTypes(
  "profile/paypal/disconnect",
);

export const deleteAccountActionTypes = createActionTypes("profile/delete");

export const setContentShareTourTypes = createActionTypes(
  "profile/shareTour/set",
);

export const resetProfileActiveStreamType = "profile/stream/reset";

export const resetProfileUpcomingStreamType = "profile/upcoming-stream/reset";
